// extracted by mini-css-extract-plugin
export default {"btnsBox":"ModalAction_btnsBox__8idsX","confirmBtn":"ModalAction_confirmBtn__C6I8M"};